import React from "react";
import "./AboutUs.css";


import WhyUs from '../Whyus/WhyUs'; 
function AboutUs() {
  // Using require to load images from the assets folder
  const aboutUsImage = require("./bg1.jpg");
  const facilityImages = [
    require("./bg1.jpg"),
    require("./bg1.jpg"),
    require("./bg1.jpg"),
    require("./bg1.jpg"),
    require("./bg1.jpg"),
  ];

  return (
    <div className="about-us">
      {/* About Us Section */}
      <section id="about-us" className="about-us-section">
        <div className="container">
          <div className="grid-container">

            {/* About Us Text */}
            <div className="grid-item-text">
            <div className="about-us-image">
                {/* Rectangle 1 */}
                <div className="rectangle rectangle-1"></div>
                {/* Rectangle 2 */}
                <div className="rectangle rectangle-2"></div>
                <img src={aboutUsImage} className="about-us-img" alt="About Us" />
              </div>
            </div>
            {/* About Us Image */}
            <div className="grid-item-image">
            <h1 className="about-us-title">About Us</h1>
              <p className="about-us-text">
                Since 1995, Sawla Stone Industries has been a trusted name in manufacturing and supplying premium-quality Kota stones, Kota stone tiles, Red Mandana stones, and other building materials. Known for their durability, fine textures, and glossy finish, our products are designed to meet international quality standards.
              </p>
              <p className="about-us-text">
                Whether it's rough or polished blue and brown Kota stones or specialized tiles, we ensure high compressive strength and low water absorption, making them perfect for a wide range of applications. We take pride in offering top-notch products at competitive prices to meet the diverse needs of our clients.
              </p>
              
            </div>
          </div>
        </div>
      </section>

      {/* Our Facility Section */}
      <section id="about-us-facility" className="about-us-section">
        <div className="container">
          <div className="grid-container">
            {/* Our Facility Text */}
            <div className="grid-item-text">
              <h1 className="about-us-title">Our Facility</h1>
              <p className="about-us-text">
                Located on a vast 15,000 sq. meter site, our facility is equipped with cutting-edge technology. We utilize eight stone cutter machines, eleven edge cutting machines, ten manual polishing machines, one calibration cum polishing machine, and an automatic line polish machine for tiles. Our infrastructure ensures precision, quality, and efficiency in every product we deliver.
              </p>
            </div>
            
            {/* Our Facility Images */}
            <div className="grid-item-image">
              <div className="about-us-image1">
                {facilityImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    className={`about-us-img-${index + 1}`}
                    alt={`Facility Image ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Why Choose Us Section */}
      <WhyUs />
    
    </div>
  );
}

export default AboutUs;
